const imageArchiveNorwegian = {
  header: {
    title: "Bildearkiv",
    description: "Last opp og administrer bilder til dine LinkedIn-innlegg."
  },
  upload: {
    dragDrop: "Dra og slipp bilder her",
    clickUpload: "eller klikk for å velge bilder",
    uploading: "Laster opp...",
    uploadButton: "Last opp bilder",
    progress: "Opplastingsfremgang"
  },
  gallery: {
    title: "Mine bilder",
    empty: "Ingen bilder ennå",
    uploadFirst: "Last opp dine første bilder ovenfor",
    imageActions: {
      copy: "Kopier URL",
      delete: "Slett bilde"
    },
    deleteConfirm: "Er du sikker på at du vil slette bildet \"{name}\"?"
  },
  notification: {
    uploadSuccess: "{count} {count, plural, =1 {bilde} other {bilder}} lastet opp til ditt bildearkiv.",
    uploadTelegramSuccess: "Bilde lastet opp til Telegram og klar til bruk i dine innlegg",
    uploadTelegramFail: "Bildet er lagret i arkivet ditt, men kunne ikke sendes til Telegram.",
    deleteSuccess: "Bildet er slettet.",
    deleteFail: "Det oppstod en feil ved sletting av bildet.",
    copySuccess: "Bilde-URL kopiert til utklippstavle.",
    copyFail: "Kunne ikke kopiere URL.",
    generalError: "Det oppstod en feil. Prøv igjen senere."
  },
  customerBanner: "Du administrerer bildearkiv for {customerName}",
  messages: {
    onlyImageFiles: "Kun bildefiler er tillatt.",
    noValidUserId: "Kunne ikke finne gyldig bruker-ID."
  }
};

export default imageArchiveNorwegian; 